import React from "react"
import Fab from "components/Fab"
import { withAccessRoles } from "app/components/AccessRoles"
import BuildIcon from "@material-ui/icons/Build"

interface RestProps {
  onClick: () => void
}

type Props = RestProps

function SupportSettingsTogglerButton({ onClick }: Props) {
  return (
    <Fab color="primary" data-cy="planning-switchCompany-action" onClick={onClick}>
      <BuildIcon />
    </Fab>
  )
}

export default withAccessRoles<Props>(SupportSettingsTogglerButton)
